(function () {
  "use strict";

  var DATA_URL =
    document.currentScript
      ? document.currentScript.src.replace(/hard-water-map\.js(\?.*)?$/, "hard-water-map-public.json?v=" + Date.now())
      : "/assets/hard-water-map-public.json";

  var root = document.querySelector("[data-hard-water-map-root]");
  if (!root) return;

  var form = root.querySelector("#ff-hwm-search-form");
  var input = root.querySelector("#ff-hwm-postcode");
  var button = root.querySelector(".ff-hwm__search-btn");
  var resultRegion = root.querySelector("#ff-hwm-result");
  var resultRow = root.querySelector("#ff-hwm-result-row");
  var tooltip = root.querySelector("#ff-hwm-map-tooltip");
  var map = root.querySelector(".ff-hwm__map");
  var tableBody = root.querySelector("#ff-hwm-areas-table tbody");
  var tableFilterInput = root.querySelector("#ff-hwm-table-filter");
  var tableNoResults = root.querySelector("#ff-hwm-table-no-results");
  var tableToggle = root.querySelector("#ff-hwm-table-toggle");
  var tableRows = tableBody ? Array.prototype.slice.call(tableBody.querySelectorAll("tr")) : [];

  /* ── Inject invisible Turnstile container into the search form early ── */
  if (form) {
    var _tsContainer = document.createElement("div");
    _tsContainer.id = "ff-hwm-turnstile";
    _tsContainer.style.display = "none";
    form.appendChild(_tsContainer);
  }

  var WORKER_URL = "https://filter-flair-postcode-proxy.mark-jones-5ce.workers.dev";
  var TURNSTILE_SITE_KEY = "0x4AAAAAACypIvdMm20gG8wJ";
  var turnstileWidgetId = null;
  var turnstileReady = false;
  var turnstilePendingResolve = null;  /* resolve fn waiting for next token */
  var turnstilePendingReject  = null;  /* reject fn waiting for next token */

  /* ── Load Turnstile script once ── */
  (function () {
    if (document.querySelector('script[src*="turnstile"]')) return;
    var s = document.createElement("script");
    s.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=ffHwmTurnstileReady";
    s.async = true;
    s.defer = true;
    document.head.appendChild(s);
  })();

  window.ffHwmTurnstileReady = function () {
    turnstileReady = true;
    renderTurnstileWidget();
  };

  function renderTurnstileWidget() {
    if (!turnstileReady || !window.turnstile) return;
    var container = root.querySelector("#ff-hwm-turnstile");
    if (!container || turnstileWidgetId !== null) return;
    /* Callback fires when a fresh token is ready after execute() is called */
    turnstileWidgetId = window.turnstile.render(container, {
      sitekey: TURNSTILE_SITE_KEY,
      size: "invisible",
      execution: "execute",
      "refresh-expired": "auto",
      callback: function (token) {
        /* Resolve any pending promise waiting for a token */
        if (turnstilePendingResolve) {
          var res = turnstilePendingResolve;
          turnstilePendingResolve = null;
          turnstilePendingReject  = null;
          res(token);
        }
      },
      "error-callback": function () {
        if (turnstilePendingReject) {
          var rej = turnstilePendingReject;
          turnstilePendingResolve = null;
          turnstilePendingReject  = null;
          rej(new Error("Security check failed. Please refresh and try again."));
        }
      },
    });
  }

  function resetTurnstile() {
    /* Reset widget so it can issue a fresh token on the next execute() call */
    if (window.turnstile && turnstileWidgetId !== null) {
      window.turnstile.reset(turnstileWidgetId);
    }
  }

  function getTurnstileToken() {
    return new Promise(function (resolve, reject) {
      var maxWait = 10000; /* ms to wait for Turnstile to initialise */
      var interval = 100;
      var elapsed = 0;

      function tryExecute() {
        if (window.turnstile && turnstileWidgetId !== null) {
          /* Store the resolve/reject so the render callback can fire them */
          turnstilePendingResolve = resolve;
          turnstilePendingReject  = reject;
          /* Trigger the challenge - token will arrive via the render callback */
          window.turnstile.execute(turnstileWidgetId);
          return;
        }
        elapsed += interval;
        if (elapsed >= maxWait) {
          reject(new Error("Security check timed out. Please refresh the page and try again."));
          return;
        }
        setTimeout(tryExecute, interval);
      }

      tryExecute();
    });
  }

  var areaData = null;
  var areaDataByOutcode = null;
  var mobileRowsCollapsed = true;
  var maxCollapsedRows = 10;
  var isMobileQuery = window.matchMedia("(max-width: 720px)");

  var CLASS_META = {
    Soft: {
      slug: "soft",
      icon: "\uD83D\uDCA7",
      implication: "Soft water is low in dissolved calcium and magnesium, so limescale is minimal and soap usually lathers easily.",
      recommendation: {
        label: "Shop carbon filters",
        href: "/collections/carbon-filters",
        body: "A carbon filter is usually enough if your main concern is taste, chlorine, or drinking-water quality rather than hardness reduction."
      }
    },
    "Moderately Hard": {
      slug: "moderately-hard",
      icon: "\uD83D\uDCA7",
      implication: "Moderately hard water usually causes some visible scale over time, particularly on kettles, shower glass, and taps.",
      recommendation: {
        label: "Shop shower filters",
        href: "/collections/shower-filters",
        body: "A shower filter reduces chlorine and softens the feel of water at the showerhead — a noticeable improvement for skin and hair in moderately hard areas."
      }
    },
    Hard: {
      slug: "hard",
      icon: "\u26A0\uFE0F",
      implication: "Hard water usually means regular limescale build-up, more soap use, and more strain on water-using appliances.",
      recommendation: {
        label: "Shop whole house systems",
        href: "/collections/whole-house-systems",
        body: "A whole-house filtration system with a polyphosphate stage inhibits limescale at every tap, shower, and appliance — without the salt or maintenance of a traditional softener."
      }
    },
    "Very Hard": {
      slug: "very-hard",
      icon: "\u26A0\uFE0F",
      implication: "Very hard water is the strongest limescale risk and has the clearest case for whole-home treatment.",
      recommendation: {
        label: "Shop whole house systems",
        href: "/collections/whole-house-systems",
        body: "In very hard-water areas, the BMB-1000 Hydra whole-house system is the most effective way to protect appliances and reduce scale — no salt, no maintenance."
      }
    },
    Unavailable: {
      slug: "unavailable",
      icon: "\u2014",
      implication: "We do not currently have a published hardness reading for this area in the local dataset.",
      recommendation: {
        label: "Browse all filters",
        href: "/collections/all",
        body: "If you are comparing treatment options, browse the wider range or check your supplier's own report for a precise local reading."
      }
    }
  };

  /* ---- helpers ---- */

  function normalisePostcode(raw) {
    return raw.trim().toUpperCase().replace(/\s+/g, "");
  }

  function formatPostcodeForDisplay(raw) {
    var compact = normalisePostcode(raw);
    if (compact.length <= 3) return compact;
    return compact.slice(0, -3) + " " + compact.slice(-3);
  }

  function extractOutcode(postcode) {
    var compact = normalisePostcode(postcode);
    return compact.slice(0, -3);
  }

  function isValidPostcode(postcode) {
    return /^[A-Z]{1,2}\d[A-Z\d]?\d[A-Z]{2}$/.test(normalisePostcode(postcode));
  }

  function isBTPostcode(postcode) {
    return /^BT/.test(extractOutcode(postcode));
  }

  /* Static BT outcode → N09 district mapping (NI Water supply zones, 2024) */
  var BT_OUTCODE_MAP = {
    "BT1":  "N09000003", "BT2":  "N09000003", "BT3":  "N09000003",
    "BT4":  "N09000003", "BT5":  "N09000003", "BT6":  "N09000003",
    "BT7":  "N09000003", "BT8":  "N09000003", "BT9":  "N09000003",
    "BT10": "N09000003", "BT11": "N09000003", "BT12": "N09000003",
    "BT13": "N09000003", "BT14": "N09000003", "BT15": "N09000003",
    "BT16": "N09000003", "BT17": "N09000003",
    "BT18": "N09000011", "BT19": "N09000011", "BT20": "N09000011",
    "BT21": "N09000011", "BT22": "N09000011", "BT23": "N09000011",
    "BT24": "N09000010", "BT25": "N09000010", "BT26": "N09000010",
    "BT27": "N09000007", "BT28": "N09000007", "BT29": "N09000007",
    "BT30": "N09000010", "BT31": "N09000010", "BT32": "N09000002",
    "BT33": "N09000010", "BT34": "N09000010", "BT35": "N09000010",
    "BT36": "N09000001", "BT37": "N09000001", "BT38": "N09000001",
    "BT39": "N09000008", "BT40": "N09000008", "BT41": "N09000001",
    "BT42": "N09000008", "BT43": "N09000008", "BT44": "N09000008",
    "BT45": "N09000009", "BT46": "N09000009", "BT47": "N09000005",
    "BT48": "N09000005", "BT49": "N09000004",
    "BT51": "N09000004", "BT52": "N09000004", "BT53": "N09000004",
    "BT54": "N09000004", "BT55": "N09000004", "BT56": "N09000004",
    "BT57": "N09000004",
    "BT60": "N09000002", "BT61": "N09000002", "BT62": "N09000002",
    "BT63": "N09000002", "BT64": "N09000002", "BT65": "N09000002",
    "BT66": "N09000002", "BT67": "N09000002",
    "BT68": "N09000009", "BT69": "N09000009", "BT70": "N09000009",
    "BT71": "N09000009", "BT74": "N09000006", "BT75": "N09000006",
    "BT76": "N09000006", "BT77": "N09000006", "BT78": "N09000006",
    "BT79": "N09000006", "BT80": "N09000009",
    "BT81": "N09000005", "BT82": "N09000005",
    "BT92": "N09000006", "BT93": "N09000006", "BT94": "N09000006"
  };

  function lookupBTPostcode(postcode) {
    var outcode = extractOutcode(normalisePostcode(postcode));
    return BT_OUTCODE_MAP[outcode] || null;
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function getClassMeta(classification) {
    return CLASS_META[classification] || CLASS_META.Unavailable;
  }

  function getCoverageLabel(record) {
    if (record.coverage_status === "estimated") return "Regional estimate";
    if (record.coverage_status === "unavailable") return "Currently unavailable";
    return "Measured supplier data";
  }

  function getSourceNote(record) {
    if (record.source_note) {
      if (record.source_url) {
        return escapeHtml(record.source_note) + ' <a href="' + escapeHtml(record.source_url) + '" target="_blank" rel="noopener">See source</a>.';
      }
      return escapeHtml(record.source_note);
    }

    var label = getCoverageLabel(record);
    var date = record.source_date ? " (" + record.source_date + ")" : "";
    if (record.source_url) {
      return label + ': <a href="' + escapeHtml(record.source_url) + '" target="_blank" rel="noopener">' + escapeHtml(record.water_company) + "</a>" + escapeHtml(date);
    }
    return escapeHtml(label + " \u2014 " + record.water_company + date);
  }

  /* ---- data loading ---- */

  function loadData() {
    if (areaData) return Promise.resolve(areaData);
    return fetch(DATA_URL)
      .then(function (response) {
        if (!response.ok) throw new Error("Could not load area data.");
        return response.json();
      })
      .then(function (json) {
        /* New public format: outcode -> { d: admin_district_code, c: classification, n: area_name }
           Build an index by admin_district_code for map/table lookups */
        var byDistrict = {};
        var byOutcode = {};
        Object.keys(json).forEach(function (outcode) {
          var rec = json[outcode];
          if (!rec || !rec.d) return;
          var entry = {
            outcode: outcode,
            admin_district_code: rec.d,
            ff_classification: rec.c,
            area_name: rec.n,
          };
          byOutcode[outcode] = entry;
          /* Keep one representative entry per district for map colouring */
          if (!byDistrict[rec.d]) byDistrict[rec.d] = entry;
        });
        areaData = byDistrict;
        areaDataByOutcode = byOutcode;
        return areaData;
      });
  }

  function lookupPostcode(postcode) {
    return getTurnstileToken()
      .then(function (token) {
        /* Token is single-use — reset immediately so next submission gets a fresh one */
        resetTurnstile();
        return fetch(WORKER_URL, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ postcode: normalisePostcode(postcode), token: token }),
        });
      })
      .then(function (response) {
        if (response.status === 403) throw new Error("Security check failed. Please refresh the page and try again.");
        if (response.status === 429) throw new Error("Too many lookups. Please wait a few minutes and try again.");
        if (response.status === 404) throw new Error("We do not have data for this postcode area yet.");
        if (!response.ok) throw new Error("Service temporarily unavailable. Browse the map or table below.");
        return response.json();
      })
      .then(function (json) {
        if (!json.outcode || !json.admin_district_code) {
          throw new Error("We could not match that postcode to an area.");
        }
        /* Return the full enriched record from the Worker */
        return json;
      });
  }

  function trackLookup(postcode, areaCode) {
    if (typeof window.dataLayer === "undefined") return;
    try {
      window.dataLayer.push({
        event: "hard_water_lookup",
        outcode: extractOutcode(postcode),
        area_code: areaCode
      });
    } catch (_error) { /* silent */ }
  }

  /* ---- map highlighting with dimming ---- */

  function clearHighlights() {
    root.querySelectorAll(".is-active").forEach(function (node) {
      node.classList.remove("is-active");
    });
    if (map) map.classList.remove("has-active", "ff-hwm__map--dimmed");
  }

  function highlightArea(areaCode) {
    clearHighlights();

    var matched = root.querySelectorAll('[data-area-code="' + CSS.escape(areaCode) + '"]');
    matched.forEach(function (node) {
      node.classList.add("is-active");
    });

    if (map && matched.length) {
      map.classList.add("has-active", "ff-hwm__map--dimmed");

      /* Scroll the map area into view on desktop so the highlight is visible */
      var svgPath = map.querySelector('[data-area-code="' + CSS.escape(areaCode) + '"]');
      if (svgPath && !isMobileQuery.matches) {
        try {
          var bbox = svgPath.getBBox();
          var svg = map.querySelector("svg");
          if (svg && bbox) {
            /* We don't pan the SVG, but we ensure the map frame is visible */
            var frame = root.querySelector(".ff-hwm__map-frame");
            if (frame) {
              frame.scrollIntoView({ behavior: "smooth", block: "nearest" });
            }
          }
        } catch (_e) { /* getBBox can fail on hidden elements */ }
      }
    }

    tableRows.forEach(function (row) {
      row.classList.toggle("is-active", row.dataset.areaCode === areaCode);
    });
  }

  /* ---- result rendering ---- */

  function renderResult(record, options) {
    var meta = getClassMeta(record.ff_classification);
    /* For postcode lookups we have an exact ppm; for map/table clicks we show the band range */
    var PPM_RANGES = { Soft: "0–100 ppm", "Moderately Hard": "101–200 ppm", Hard: "201–300 ppm", "Very Hard": "300+ ppm" };
    var ppm = typeof record.source_ppm === "number"
      ? record.source_ppm + " ppm"
      : (PPM_RANGES[record.ff_classification] || "See postcode checker");
    var label = options && options.label ? options.label : "Area matched";
    var isPostcodeLookup = !!(options && options.lookupMethod === 'postcode');
    /* Prefix outcode to label for postcode lookups */
    if (isPostcodeLookup && record.outcode) {
      label = record.outcode + ' · ' + label;
    }

    /* Hardness meter — fill width as % of 400 ppm max */
    /* Use midpoint of band for meter when exact ppm not available */
    var PPM_MIDPOINTS = { Soft: 55, "Moderately Hard": 150, Hard: 250, "Very Hard": 350 };
    var ppmVal = typeof record.source_ppm === 'number' ? record.source_ppm : (PPM_MIDPOINTS[record.ff_classification] || 0);
    var meterPct = Math.min(Math.round((ppmVal / 400) * 100), 100);

    /* ── Water quality panel (only shown for postcode lookups with data) ── */
    function fmtNum(val, unit, decimals) {
      if (val === null || val === undefined) return null;
      var n = typeof decimals === 'number' ? Number(val).toFixed(decimals) : val;
      return unit ? n + ' ' + unit : String(n);
    }
    function qualityRow(label, val, status) {
      if (val === null || val === undefined) return '';
      /* status: 'ok' | 'warn' | 'alert' | null */
      var dot = status ? '<span class="ff-hwm__quality-dot ff-hwm__quality-dot--' + status + '" title="' + (status === 'ok' ? 'Within safe limits' : status === 'warn' ? 'Approaching limit' : 'Exceeds guideline') + '"></span>' : '';
      var badge = status ? '<span class="ff-hwm__quality-status ff-hwm__quality-status--' + status + '">' + (status === 'ok' ? 'Safe' : status === 'warn' ? 'Near limit' : 'High') + '</span>' : '';
      return '<div class="ff-hwm__quality-row"><span class="ff-hwm__quality-label">' + dot + escapeHtml(label) + '</span><span class="ff-hwm__quality-value">' + escapeHtml(String(val)) + badge + '</span></div>';
    }
    /* Return 'ok', 'warn', or 'alert' based on WHO/DWI thresholds */
    function safetyStatus(key, rawVal) {
      if (rawVal === null || rawVal === undefined) return null;
      var v = Number(rawVal);
      if (isNaN(v)) return null;
      /* Thresholds: [warn, alert] — DWI/WHO limits */
      var limits = {
        ph:            [null, null],   /* no single limit; 6.5-9.5 acceptable */
        chlorine_free: [0.8,  1.0],   /* DWI max 1.0 mg/L */
        fluoride:      [1.0,  1.5],   /* WHO 1.5 mg/L */
        nitrate:       [37,   50],    /* DWI 50 mg/L NO3 */
        lead:          [5,    10],    /* DWI 10 µg/L */
        iron:          [100,  200],   /* DWI 200 µg/L */
        turbidity:     [1,    4],     /* DWI 4 NTU */
        tds:           [500,  1000],  /* WHO 1000 mg/L */
      };
      var t = limits[key];
      if (!t) return null;
      /* pH special case: acceptable range 6.5-9.5 */
      if (key === 'ph') {
        if (v < 6.5 || v > 9.5) return 'alert';
        if (v < 7.0 || v > 9.0) return 'warn';
        return 'ok';
      }
      if (t[1] !== null && v >= t[1]) return 'alert';
      if (t[0] !== null && v >= t[0]) return 'warn';
      return 'ok';
    }

    var qualityPanel = '';
    if (isPostcodeLookup && record.has_quality_data) {
      var qRows = [
        qualityRow('pH', fmtNum(record.ph, '', 1), safetyStatus('ph', record.ph)),
        qualityRow('Free chlorine', fmtNum(record.chlorine_free, 'mg/L', 2), safetyStatus('chlorine_free', record.chlorine_free)),
        qualityRow('Fluoride', fmtNum(record.fluoride, 'mg/L', 2), safetyStatus('fluoride', record.fluoride)),
        qualityRow('Nitrate', fmtNum(record.nitrate, 'mg/L', 1), safetyStatus('nitrate', record.nitrate)),
        qualityRow('Lead', fmtNum(record.lead, '\u03BCg/L', 2), safetyStatus('lead', record.lead)),
        qualityRow('Iron', fmtNum(record.iron, '\u03BCg/L', 0), safetyStatus('iron', record.iron)),
        qualityRow('Turbidity', fmtNum(record.turbidity, 'NTU', 2), safetyStatus('turbidity', record.turbidity)),
        qualityRow('TDS', fmtNum(record.tds, 'mg/L', 0), safetyStatus('tds', record.tds)),
      ].filter(Boolean).join('');

      if (qRows) {
        /* Gated: hidden until email sign-up is completed */
        var alreadyUnlocked = (typeof sessionStorage !== 'undefined' && sessionStorage.getItem('ff-hwm-unlocked') === '1');
        qualityPanel = [
          '<div class="ff-hwm__quality-panel ff-hwm__quality-panel--gated' + (alreadyUnlocked ? '' : ' ff-hwm__quality-panel--locked') + '">',
          '  <p class="ff-hwm__quality-heading">Water quality parameters</p>',
          '  <div class="ff-hwm__quality-grid">',
          qRows,
          '  </div>',
          '</div>',
        ].join('');
      }
    }

    /* ── Hardness unit conversions (only for postcode lookups) ── */
    var unitsPanel = '';
    if (isPostcodeLookup && record.source_ppm) {
      var unitRows = [
        record.hardness_clark  != null ? qualityRow('Clark (\u00b0e)', Number(record.hardness_clark).toFixed(1))  : '',
        record.hardness_french != null ? qualityRow('French (\u00b0f)', Number(record.hardness_french).toFixed(1)) : '',
        record.hardness_german != null ? qualityRow('German (\u00b0dH)', Number(record.hardness_german).toFixed(1)) : '',
        record.hardness_mmol   != null ? qualityRow('mmol/L', Number(record.hardness_mmol).toFixed(2))   : '',
        record.calcium_mg_l    != null ? qualityRow('Calcium', fmtNum(record.calcium_mg_l, 'mg/L', 1))   : '',
        record.magnesium_mg_l  != null ? qualityRow('Magnesium', fmtNum(record.magnesium_mg_l, 'mg/L', 1)) : '',
      ].filter(Boolean).join('');

      if (unitRows) {
        unitsPanel = [
          '<details class="ff-hwm__quality-panel ff-hwm__quality-panel--units ff-hwm__units-toggle">',
          '  <summary class="ff-hwm__units-summary">',
          '    <span class="ff-hwm__quality-heading">Hardness in other units</span>',
          '    <span class="ff-hwm__units-chevron" aria-hidden="true"></span>',
          '  </summary>',
          '  <div class="ff-hwm__quality-grid ff-hwm__units-body">',
          unitRows,
          '  </div>',
          '</details>',
        ].join('');
      }
    }

    return [
      '<div class="ff-hwm__result-card ff-hwm__result-card--' + meta.slug + '">',

      /* ── Compact header: label · badge on one line, then area + ppm on next ── */
      '  <div class="ff-hwm__result-header">',
      '    <div class="ff-hwm__result-topline">',
      '      <p class="ff-hwm__result-label">' + escapeHtml(label) + '</p>',
      '      <span class="ff-hwm-badge ff-hwm-badge--' + meta.slug + '">' + escapeHtml(record.ff_classification) + '</span>',
      '    </div>',
      '    <div class="ff-hwm__result-hero">',
      '      <h2 class="ff-hwm__result-area">' + escapeHtml(record.area_name) + (record.outcode ? ' <span class="ff-hwm__result-outcode">' + escapeHtml(record.outcode) + '</span>' : '') + '</h2>',
      '      <div class="ff-hwm__result-ppm-hero">',
      '        <span class="ff-hwm__result-ppm-value">' + escapeHtml(ppm) + '</span>',
      '        <span class="ff-hwm__result-ppm-label">calcium carbonate</span>',
      '      </div>',
      '    </div>',
      /* National average line — inside header, below the city name/ppm row */
      (isPostcodeLookup && ppmVal > 0) ? (function() {
        var pct;
        if (ppmVal <= 100)      { pct = Math.round((ppmVal / 100) * 35); }
        else if (ppmVal <= 200) { pct = 35 + Math.round(((ppmVal - 100) / 100) * 20); }
        else if (ppmVal <= 300) { pct = 55 + Math.round(((ppmVal - 200) / 100) * 25); }
        else                    { pct = 80 + Math.round(Math.min(((ppmVal - 300) / 200) * 20, 19)); }
        var softerThan = 100 - pct;
        var compText = softerThan >= 50
          ? record.area_name + ' is softer than <strong>' + softerThan + '% of UK postcodes</strong>'
          : record.area_name + ' is harder than <strong>' + pct + '% of UK postcodes</strong>';
        return '    <p class="ff-hwm__national-avg">' + compText + '</p>';
      })() : '',
      '  </div>',

      /* ── Hardness meter bar ── */
      '  <div class="ff-hwm__result-meter" aria-label="Hardness level: ' + meterPct + '%">',
      '    <div class="ff-hwm__result-meter-track">',
      '      <div class="ff-hwm__result-meter-fill ff-hwm__result-meter-fill--' + meta.slug + '" style="width:' + meterPct + '%"></div>',
      /* Nubs at zone boundaries: soft/mod=0%, mod/hard=25% (100ppm), hard/vhard=50% (200ppm), end=75% (300ppm) */
      '      <div class="ff-hwm__meter-nub" style="left:25%"></div>',
      '      <div class="ff-hwm__meter-nub" style="left:50%"></div>',
      '      <div class="ff-hwm__meter-nub" style="left:75%"></div>',
      '    </div>',
      '    <div class="ff-hwm__result-meter-labels">',
      '      <span>Soft</span><span>Moderate</span><span>Hard</span><span>Very Hard</span>',
      '    </div>',
      '  </div>',

      /* ── Stats row — single inline strip ── */
      '  <div class="ff-hwm__result-stats ff-hwm__result-stats--inline">',
      record.water_company ? [
        '    <div class="ff-hwm__result-stat">',
        '      <span class="ff-hwm__result-stat-label">Water company</span>',
        '      <span class="ff-hwm__result-stat-value">' + escapeHtml(record.water_company) + '</span>',
        '    </div>',
      ].join('') : '',
      record.supply_zone ? [
        '    <div class="ff-hwm__result-stat">',
        '      <span class="ff-hwm__result-stat-label">Supply zone</span>',
        '      <span class="ff-hwm__result-stat-value">' + escapeHtml(record.supply_zone) + '</span>',
        '    </div>',
      ].join('') : '',
      '    <div class="ff-hwm__result-stat">',
      '      <span class="ff-hwm__result-stat-label">' + (record.coverage_status === 'measured' ? 'Data source' : 'Confidence') + '</span>',
      '      <span class="ff-hwm__result-stat-value">' + escapeHtml(getCoverageLabel(record)) + (record.source_year ? ' \u00b7 ' + record.source_year : '') + '</span>',
      '    </div>',
      '  </div>',

      /* ── Implication + recommendation ── */
      '  <div class="ff-hwm__result-copy">',
      '    <p class="ff-hwm__result-implication">' + escapeHtml(meta.implication) + '</p>',
      '    <p class="ff-hwm__result-recommendation">' + escapeHtml(meta.recommendation.body) + '</p>',
      '    <a class="ff-hwm__result-cta-btn" href="' + escapeHtml(meta.recommendation.href) + '">' + escapeHtml(meta.recommendation.label) + ' &rarr;</a>',
      '  </div>',

      /* ── Left stack: email capture + units + quality (flex column, collapses on confirm) ── */
      '  <div class="ff-hwm__result-left-stack">',

      /* ── Email capture ── */
      '  <div class="ff-hwm__result-email-capture">',
      '    <div class="ff-hwm__result-email-content">',
      '      <p class="ff-hwm__result-email-heading">Get your complete water report</p>',
      '      <p class="ff-hwm__result-email-sub">Get a personalised water quality report and filter recommendation for ' + escapeHtml(record.area_name) + ' straight to your inbox.</p>',
      '      <form class="ff-hwm__result-email-form"'
      + ' data-area="' + escapeHtml(record.area_name) + '"'
      + ' data-ppm="' + escapeHtml(ppm) + '"'
      + ' data-classification="' + escapeHtml(record.ff_classification) + '"'
      + ' data-postcode="' + escapeHtml(options && options.postcode ? options.postcode : '') + '"'
      + ' data-lookup-method="' + escapeHtml(options && options.lookupMethod ? options.lookupMethod : 'map') + '"'
      + ' data-outcode="' + escapeHtml(record.outcode || '') + '"'
      + ' data-water-company="' + escapeHtml(record.water_company || '') + '"'
      + ' data-supply-zone="' + escapeHtml(record.supply_zone || '') + '"'
      + ' data-ph="' + escapeHtml(record.ph != null ? String(record.ph) : '') + '"'
      + ' data-chlorine="' + escapeHtml(record.chlorine_free != null ? String(record.chlorine_free) : '') + '"'
      + ' data-fluoride="' + escapeHtml(record.fluoride != null ? String(record.fluoride) : '') + '"'
      + ' data-nitrate="' + escapeHtml(record.nitrate != null ? String(record.nitrate) : '') + '"'
      + ' data-lead="' + escapeHtml(record.lead != null ? String(record.lead) : '') + '"'
      + ' data-iron="' + escapeHtml(record.iron != null ? String(record.iron) : '') + '"'
      + ' data-turbidity="' + escapeHtml(record.turbidity != null ? String(record.turbidity) : '') + '"'
      + ' data-tds="' + escapeHtml(record.tds != null ? String(record.tds) : '') + '"'
      + ' data-calcium="' + escapeHtml(record.calcium_mg_l != null ? String(record.calcium_mg_l) : '') + '"'
      + ' data-magnesium="' + escapeHtml(record.magnesium_mg_l != null ? String(record.magnesium_mg_l) : '') + '"'
      + ' data-hardness-clark="' + escapeHtml(record.hardness_clark != null ? String(record.hardness_clark) : '') + '"'
      + ' data-hardness-french="' + escapeHtml(record.hardness_french != null ? String(record.hardness_french) : '') + '"'
      + ' data-hardness-german="' + escapeHtml(record.hardness_german != null ? String(record.hardness_german) : '') + '"'
      + ' data-hardness-mmol="' + escapeHtml(record.hardness_mmol != null ? String(record.hardness_mmol) : '') + '"'
      + ' data-has-quality="' + escapeHtml(record.has_quality_data ? 'true' : 'false') + '"'
      + ' data-chlorine-total="' + escapeHtml(record.chlorine_total != null ? String(record.chlorine_total) : '') + '"'
      + ' data-sodium="' + escapeHtml(record.sodium != null ? String(record.sodium) : '') + '"'
      + ' data-trihalomethanes="' + escapeHtml(record.trihalomethanes != null ? String(record.trihalomethanes) : '') + '"'
      + ' data-gh="' + escapeHtml(record.gh_general_hardness != null ? String(record.gh_general_hardness) : '') + '"'
      + ' data-kh="' + escapeHtml(record.kh_carbonate_hardness != null ? String(record.kh_carbonate_hardness) : '') + '"'
      + ' data-arsenic="' + escapeHtml(record.arsenic != null ? String(record.arsenic) : '') + '"'
      + ' data-copper="' + escapeHtml(record.copper != null ? String(record.copper) : '') + '"'
      + ' data-manganese="' + escapeHtml(record.manganese != null ? String(record.manganese) : '') + '"'
      + ' data-e-coli="' + escapeHtml(record.e_coli != null ? String(record.e_coli) : '') + '"'
      + ' data-coliform="' + escapeHtml(record.coliform_bacteria != null ? String(record.coliform_bacteria) : '') + '"'
      + ' data-pesticides="' + escapeHtml(record.pesticides != null ? String(record.pesticides) : '') + '"'
      + ' novalidate>',
      '        <div class="ff-hwm__result-email-row">',
      '          <input class="ff-hwm__result-email-input" type="email" placeholder="Your email address" autocomplete="email" required>',
      '          <button class="ff-hwm__result-email-btn" type="submit">Get my report</button>',
      '        </div>',
      '        <p class="ff-hwm__result-email-privacy">No spam. Unsubscribe any time.</p>',
      '      </form>',
      '    </div>',
      '    <div class="ff-hwm__result-email-confirm" aria-live="polite">',
      '      <svg class="ff-hwm__result-email-confirm-icon" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="m2 7 8.586 6.414a2 2 0 0 0 2.828 0L22 7"/></svg>',
      '      <div>',
      '        <p class="ff-hwm__result-email-confirm-title">Report on its way!</p>',
      '        <p class="ff-hwm__result-email-confirm-body">Check your inbox for your personalised ' + escapeHtml(record.area_name) + ' water report.</p>',
      '      </div>',
      '    </div>',
      '  </div>',

      /* ── Units + quality panels inside left stack ── */
      unitsPanel,
      qualityPanel,

      /* ── Close left stack ── */
      '  </div>',

      /* ── Share row ── */
      '  <div class="ff-hwm__result-share" data-share-code="' + escapeHtml(options && options.areaCode ? options.areaCode : '') + '" data-share-area="' + escapeHtml(record.area_name) + '" data-share-ppm="' + escapeHtml(ppm) + '" data-share-classification="' + escapeHtml(record.ff_classification) + '">',
      '    <span class="ff-hwm__result-share-label">Share</span>',
      '    <div class="ff-hwm__result-share-btns">',
      '      <button class="ff-hwm__share-btn ff-hwm__share-btn--whatsapp" data-share="whatsapp" aria-label="Share on WhatsApp">',
      '        <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>',
      '      </button>',
      '      <button class="ff-hwm__share-btn ff-hwm__share-btn--twitter" data-share="twitter" aria-label="Share on X">',
      '        <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.744l7.737-8.835L1.254 2.25H8.08l4.253 5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>',
      '      </button>',
      '      <button class="ff-hwm__share-btn ff-hwm__share-btn--facebook" data-share="facebook" aria-label="Share on Facebook">',
      '        <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>',
      '      </button>',
      '      <button class="ff-hwm__share-btn ff-hwm__share-btn--copy" data-share="copy" aria-label="Copy link">',
      '        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path></svg>',
      '        Copy link',
      '      </button>',
      '    </div>',
      '  </div>',

      '</div>'
    ].join('\n');
  }

  function renderMessage(message, variant) {
    var tone = variant || "unavailable";
    return [
      '<div class="ff-hwm__result-card ff-hwm__result-card--' + tone + '">',
      '  <p class="ff-hwm__result-label">Lookup status</p>',
      '  <p class="ff-hwm__result-error">' + escapeHtml(message) + "</p>",
      "</div>"
    ].join("\n");
  }

  function showResult(html) {
    resultRegion.innerHTML = html;
    if (resultRow) resultRow.hidden = false;
  }

  function setButtonState(isLoading) {
    button.disabled = isLoading;
    button.innerHTML = isLoading ? "Checking&hellip;" : "Check my water &rarr;";
  }

  function scrollResultIntoView() {
    var target = resultRow || resultRegion;
    if (!target) return;
    // Measure sticky header height so we don't scroll under it
    var headerOffset = 0;
    var stickyHeader = document.querySelector('.site-header, .header-wrapper, header.shopify-section, #shopify-section-header, .header');
    if (stickyHeader) {
      headerOffset = stickyHeader.getBoundingClientRect().height;
    }
    var extraPadding = 16; // a little breathing room above the result
    var rect = target.getBoundingClientRect();
    var absoluteTop = rect.top + window.pageYOffset;
    window.scrollTo({ top: absoluteTop - headerOffset - extraPadding, behavior: 'smooth' });
  }

  /* ---- tooltip (enhanced with badge) ---- */

  function showTooltipFor(target, event) {
    if (!tooltip || !target) return;

    var areaCode = target.dataset.areaCode;
    if (!areaCode || !areaData || !areaData[areaCode]) return;

    var record = areaData[areaCode];
    var meta = getClassMeta(record.ff_classification);

    tooltip.innerHTML = [
      '<div style="text-align:center">',
      '  <strong style="display:block;font-size:.9rem;margin-bottom:.35rem">' + escapeHtml(record.area_name) + "</strong>",
      '  <span class="ff-hwm-badge ff-hwm-badge--' + meta.slug + '" style="font-size:.68rem;min-height:1.4rem;padding:.1rem .5rem">' + escapeHtml(record.ff_classification) + "</span>",
      '  <div style="font-size:.78rem;opacity:.75;margin-top:.35rem">Enter your postcode for exact data</div>',
      "</div>"
    ].join("");

    tooltip.hidden = false;

    /* Use class-based visibility for CSS transition */
    requestAnimationFrame(function () {
      tooltip.classList.add("is-visible");
    });

    var mapRect = map.getBoundingClientRect();
    var x, y;

    if (event && typeof event.clientX === "number") {
      x = event.clientX - mapRect.left;
      y = event.clientY - mapRect.top;
    } else {
      var targetRect = target.getBoundingClientRect();
      x = targetRect.left - mapRect.left + targetRect.width / 2;
      y = targetRect.top - mapRect.top;
    }

    var tooltipW = tooltip.offsetWidth || 200;
    var tooltipH = tooltip.offsetHeight || 60;

    /* Position: prefer right-below cursor, but flip if near edges */
    var posX = Math.max(8, Math.min(x + 16, mapRect.width - tooltipW - 8));
    var posY = Math.max(8, y - tooltipH - 12);
    if (posY < 8) posY = y + 20;

    tooltip.style.left = posX + "px";
    tooltip.style.top = posY + "px";
  }

  function hideTooltip() {
    if (!tooltip) return;
    tooltip.classList.remove("is-visible");
    tooltip.hidden = true;
  }

  /* ---- area selection ---- */

  function setResultForAreaCode(areaCode, options) {
    return loadData().then(function (areas) {
      var record = areas[areaCode];
      if (!record) {
        showResult(renderMessage("We do not have data for this area yet.", "error"));
        clearHighlights();
        return;
      }

      options = options || {};
      options.areaCode = areaCode;
      showResult(renderResult(record, options));
      highlightArea(areaCode);
      scrollResultIntoView();
    });
  }

  /* ---- table interactions ---- */

  function visibleRowsAfterFilter() {
    return tableRows.filter(function (row) { return !row.hidden; });
  }

  function applyCollapsedRows() {
    if (!tableRows.length) return;

    var query = tableFilterInput ? tableFilterInput.value.trim() : "";
    var shouldCollapse = isMobileQuery.matches && mobileRowsCollapsed && !query;
    var visibleIndex = 0;

    tableRows.forEach(function (row) {
      if (row.hidden) { row.dataset.rowHidden = "false"; return; }
      visibleIndex += 1;
      row.dataset.rowHidden = shouldCollapse && visibleIndex > maxCollapsedRows ? "true" : "false";
    });

    if (!tableToggle) return;

    tableToggle.hidden = !isMobileQuery.matches || tableRows.length <= maxCollapsedRows;
    tableToggle.setAttribute("aria-expanded", mobileRowsCollapsed ? "false" : "true");
    tableToggle.textContent = mobileRowsCollapsed ? "Show all areas" : "Show fewer areas";
  }

  function applyTableFilter() {
    if (!tableFilterInput || !tableRows.length) return;

    var query = tableFilterInput.value.trim().toLowerCase();

    tableRows.forEach(function (row) {
      var haystack = [
        row.dataset.areaCode || "",
        row.dataset.classification || "",
        row.dataset.aliases || "",
        row.textContent || ""
      ].join(" ").toLowerCase();

      row.hidden = query ? haystack.indexOf(query) === -1 : false;
    });

    var visibleCount = visibleRowsAfterFilter().length;
    if (tableNoResults) tableNoResults.hidden = visibleCount !== 0;

    applyCollapsedRows();
  }

  /* ---- map pointer events ---- */

  function handleMapPointer(event) {
    var target = event.target.closest("[data-area-code]");
    if (!target) { hideTooltip(); return; }

    loadData()
      .then(function () { showTooltipFor(target, event); })
      .catch(function () { hideTooltip(); });
  }

  function initialiseMapSelection() {
    if (!map) return;

    map.addEventListener("mousemove", handleMapPointer);
    map.addEventListener("mouseleave", hideTooltip);

    map.addEventListener("click", function (event) {
      var target = event.target.closest("[data-area-code]");
      if (!target) return;

      void setResultForAreaCode(target.dataset.areaCode, {
        label: "Area selected",
        meta: "Selected from the map"
      });
    });
  }

  function initialiseTableInteractions() {
    if (!tableBody) return;

    tableBody.addEventListener("click", function (event) {
      var row = event.target.closest("tr[data-area-code]");
      if (!row) return;

      void setResultForAreaCode(row.dataset.areaCode, {
        label: "Area selected",
        meta: "Selected from the table"
      });
    });

    if (tableFilterInput) {
      tableFilterInput.addEventListener("input", applyTableFilter);
    }

    if (tableToggle) {
      tableToggle.addEventListener("click", function () {
        mobileRowsCollapsed = !mobileRowsCollapsed;
        applyCollapsedRows();
      });
    }

    isMobileQuery.addEventListener("change", function () {
      applyCollapsedRows();
    });

    applyCollapsedRows();
  }

  /* ---- Worker record normalisation ---- */

  /**
   * Convert the Worker's enriched response into the flat record shape
   * that renderResult() expects, merging hardness + quality sub-objects.
   */
  function buildRecordFromWorker(w) {
    var h = w.hardness || {};
    var q = w.quality || {};
    var params = (q.parameters) || {};

    /* Helper: safely get a parameter value */
    function param(key) {
      var p = params[key];
      if (!p) return null;
      return p.value !== undefined ? p.value : null;
    }

    return {
      outcode:             w.outcode,
      area_name:           w.area_name,
      admin_district_code: w.admin_district_code,
      water_company:       w.water_company,
      supply_zone:         w.supply_zone,
      source_year:         w.source_year,
      source_date:         w.source_year ? String(w.source_year) : null,
      coverage_status:     w.coverage_status,
      ff_classification:   h.classification,
      source_ppm:          h.ppm,
      calcium_mg_l:        h.calcium_mg_l,
      magnesium_mg_l:      h.magnesium_mg_l,
      hardness_clark:      h.clark,
      hardness_french:     h.french,
      hardness_german:     h.german,
      hardness_mmol:       h.mmol,
      /* Water quality parameters */
      ph:                  param('ph_value'),
      chlorine_free:       param('chlorine_free'),
      chlorine_total:      param('chlorine_total'),
      fluoride:            param('fluoride'),
      nitrate:             param('nitrate_no3'),
      lead:                param('lead'),
      iron:                param('iron'),
      turbidity:           param('turbidity'),
      tds:                 q.derived && q.derived.tds ? q.derived.tds.value : null,
      gh_general_hardness: q.derived && q.derived.gh_general_hardness ? q.derived.gh_general_hardness.value : null,
      kh_carbonate_hardness: q.derived && q.derived.kh_carbonate_hardness ? q.derived.kh_carbonate_hardness.value : null,
      /* Extended quality parameters */
      chlorine_total:      param('chlorine_total'),
      sodium:              param('sodium'),
      trihalomethanes:     param('trihalomethanes_total'),
      arsenic:             param('arsenic'),
      copper:              param('copper'),
      manganese:           param('manganese'),
      e_coli:              param('e_coli'),
      coliform_bacteria:   param('coliform_bacteria'),
      pesticides:          param('pesticides_total'),
      quality_source_date: q.source_date || null,
      has_quality_data:    !!(q.parameters && Object.keys(q.parameters).length > 0),
    };
  }

  /* ---- form submission ---- */

  function handleSubmit(event) {
    event.preventDefault();

    var raw = input.value;
    var displayPostcode = formatPostcodeForDisplay(raw);

    if (!displayPostcode) {
      showResult(renderMessage("Please enter a postcode.", "error"));
      input.focus();
      return;
    }

    if (!isValidPostcode(displayPostcode)) {
      showResult(renderMessage("That does not look like a valid UK postcode. Please check and try again.", "error"));
      input.focus();
      return;
    }

    if (isBTPostcode(displayPostcode)) {
      var niAreaCode = lookupBTPostcode(displayPostcode);
      if (!niAreaCode) {
        showResult(renderMessage("We could not match that Northern Ireland postcode to a district. Please check and try again.", "error"));
        input.focus();
        return;
      }
      setButtonState(true);
      loadData().then(function (areas) {
        var record = areas[niAreaCode];
        if (!record) {
          showResult(renderMessage("We do not have data for this area yet.", "error"));
          clearHighlights();
          return;
        }
        showResult(renderResult(record, {
          label: "Postcode matched",
          meta: "Results for " + displayPostcode,
          areaCode: niAreaCode,
          postcode: displayPostcode,
          lookupMethod: 'postcode'
        }));
        highlightArea(niAreaCode);
        trackLookup(displayPostcode, niAreaCode);
        scrollResultIntoView();
      }).catch(function (error) {
        showResult(renderMessage(error && error.message ? error.message : "Something went wrong. Please try again.", "error"));
        clearHighlights();
      }).finally(function () {
        setButtonState(false);
      });
      return;
    }

    setButtonState(true);

    /* Kick off both in parallel — Worker lookup for the rich result, loadData for map colouring */
    Promise.all([lookupPostcode(displayPostcode), loadData()])
      .then(function (results) {
        var workerRecord = results[0]; /* Full enriched record from the Worker */
        var areaCode = workerRecord.admin_district_code;

        /* Build a renderResult-compatible record from the Worker response */
        var record = buildRecordFromWorker(workerRecord);

        showResult(renderResult(record, {
          label: "Postcode matched",
          meta: "Results for " + displayPostcode,
          areaCode: areaCode,
          postcode: displayPostcode,
          lookupMethod: 'postcode'
        }));

        highlightArea(areaCode);
        trackLookup(displayPostcode, areaCode);
        scrollResultIntoView();
      })
      .catch(function (error) {
        showResult(renderMessage(error && error.message ? error.message : "Something went wrong. Please try again.", "error"));
        clearHighlights();
      })
      .finally(function () {
        setButtonState(false);
      });
  }

  /* ---- query param initialisation ---- */

  function initialiseFromQueryParam() {
    var params = new URLSearchParams(window.location.search);
    var postcode = params.get("postcode");
    if (!postcode) return;

    input.value = formatPostcodeForDisplay(postcode);
    form.dispatchEvent(new Event("submit", { cancelable: true, bubbles: true }));
  }

  /* ---- zoom / pan controller ---- */

  function initialiseZoom() {
    var viewport = root.querySelector("#ff-hwm-map-viewport");
    var canvas = root.querySelector("#ff-hwm-map-canvas");
    var btnIn = root.querySelector("#ff-hwm-zoom-in");
    var btnOut = root.querySelector("#ff-hwm-zoom-out");
    var btnReset = root.querySelector("#ff-hwm-zoom-reset");
    if (!viewport || !canvas) return;

    var scale = 1;
    var tx = 0;
    var ty = 0;
    var MIN_SCALE = 1;
    var MAX_SCALE = 6;
    var STEP = 0.2;

    function applyTransform() {
      canvas.style.transform = "translate(" + tx + "px, " + ty + "px) scale(" + scale + ")";
    }

    function clampTranslation() {
      /* Allow panning only when zoomed in */
      if (scale <= 1) { tx = 0; ty = 0; return; }
      var vw = viewport.offsetWidth;
      var vh = viewport.offsetHeight;
      var maxTx = (vw * (scale - 1)) / 2;
      var maxTy = (vh * (scale - 1)) / 2;
      tx = Math.max(-maxTx, Math.min(maxTx, tx));
      ty = Math.max(-maxTy, Math.min(maxTy, ty));
    }

    function zoomTo(newScale, originX, originY) {
      /* originX/Y are relative to the viewport centre */
      var prevScale = scale;
      scale = Math.max(MIN_SCALE, Math.min(MAX_SCALE, newScale));
      if (scale !== prevScale) {
        var ratio = scale / prevScale - 1;
        tx -= (originX || 0) * ratio;
        ty -= (originY || 0) * ratio;
      }
      clampTranslation();
      applyTransform();
    }

    function resetZoom() {
      scale = 1; tx = 0; ty = 0;
      canvas.style.transition = "transform 0.2s ease";
      applyTransform();
      setTimeout(function () { canvas.style.transition = ""; }, 220);
    }

    if (btnIn) btnIn.addEventListener("click", function () { zoomTo(scale + STEP, 0, 0); });
    if (btnOut) btnOut.addEventListener("click", function () { zoomTo(scale - STEP, 0, 0); });
    if (btnReset) btnReset.addEventListener("click", resetZoom);

    /* Mouse wheel zoom */
    viewport.addEventListener("wheel", function (e) {
      e.preventDefault();
      var rect = viewport.getBoundingClientRect();
      var ox = e.clientX - rect.left - rect.width / 2;
      var oy = e.clientY - rect.top - rect.height / 2;
      var wheelStep = 0.15;
      var delta = e.deltaY < 0 ? wheelStep : -wheelStep;
      zoomTo(scale + delta, ox, oy);
    }, { passive: false });

    /* Drag to pan */
    var dragging = false;
    var dragStartX = 0;
    var dragStartY = 0;
    var dragTx = 0;
    var dragTy = 0;

    viewport.addEventListener("mousedown", function (e) {
      if (scale <= 1) return;
      dragging = true;
      dragStartX = e.clientX;
      dragStartY = e.clientY;
      dragTx = tx;
      dragTy = ty;
      viewport.classList.add("is-panning");
      e.preventDefault();
    });

    window.addEventListener("mousemove", function (e) {
      if (!dragging) return;
      tx = dragTx + (e.clientX - dragStartX);
      ty = dragTy + (e.clientY - dragStartY);
      clampTranslation();
      applyTransform();
    });

    window.addEventListener("mouseup", function () {
      if (!dragging) return;
      dragging = false;
      viewport.classList.remove("is-panning");
    });

    /* Touch pinch-to-zoom + single-finger pan */
    var lastPinchDist = null;
    var touchDragging = false;
    var touchStartX = 0;
    var touchStartY = 0;
    var touchTx = 0;
    var touchTy = 0;

    viewport.addEventListener("touchstart", function (e) {
      if (e.touches.length === 2) {
        touchDragging = false;
        lastPinchDist = Math.hypot(
          e.touches[0].clientX - e.touches[1].clientX,
          e.touches[0].clientY - e.touches[1].clientY
        );
      } else if (e.touches.length === 1 && scale > 1) {
        touchDragging = true;
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        touchTx = tx;
        touchTy = ty;
        e.preventDefault();
      }
    }, { passive: false });

    viewport.addEventListener("touchmove", function (e) {
      if (e.touches.length === 2 && lastPinchDist !== null) {
        e.preventDefault();
        var dist = Math.hypot(
          e.touches[0].clientX - e.touches[1].clientX,
          e.touches[0].clientY - e.touches[1].clientY
        );
        var ratio = dist / lastPinchDist;
        zoomTo(scale * ratio, 0, 0);
        lastPinchDist = dist;
      } else if (e.touches.length === 1 && touchDragging) {
        e.preventDefault();
        tx = touchTx + (e.touches[0].clientX - touchStartX);
        ty = touchTy + (e.touches[0].clientY - touchStartY);
        clampTranslation();
        applyTransform();
      }
    }, { passive: false });

    viewport.addEventListener("touchend", function () {
      lastPinchDist = null;
      touchDragging = false;
    }, { passive: true });
  }

  /* ---- boot ---- */

  /* Patch SVG path colours to match the data JSON on load.
     This corrects any stale baked-in fill colours without needing to redeploy the SVG. */
  var CLASS_FILL = {
    "Soft": "#b8d9f0",
    "Moderately Hard": "#6baed6",
    "Hard": "#2171b5",
    "Very Hard": "#08519c"
  };
  function patchMapColours(areas) {
    if (!map) return;
    /* areas is keyed by admin_district_code; each entry has ff_classification */
    Object.keys(areas).forEach(function (code) {
      var record = areas[code];
      var classification = record.ff_classification || record.c;
      var fill = CLASS_FILL[classification];
      if (!fill) return;
      var paths = map.querySelectorAll('[data-area-code="' + CSS.escape(code) + '"]');
      paths.forEach(function (path) {
        if (path.getAttribute("fill") !== fill) {
          path.setAttribute("fill", fill);
          path.setAttribute("data-classification", (CLASS_META[classification] || {}).slug || "");
        }
      });
    });
  }

  /* Turnstile container already injected above; just check if script loaded early */
  if (window.turnstile && !turnstileReady) {
    turnstileReady = true;
    renderTurnstileWidget();
  }

  form.addEventListener("submit", handleSubmit);

  /* Quick-access area chip clicks */
  root.querySelectorAll(".ff-hwm__quick-chip").forEach(function (chip) {
    chip.addEventListener("click", function () {
      var areaName = chip.getAttribute("data-area").toLowerCase();
      loadData().then(function (areas) {
        var match = null;
        Object.keys(areas).forEach(function (code) {
          if (!match && areas[code].area_name && areas[code].area_name.toLowerCase() === areaName) {
            match = { code: code, record: areas[code] };
          }
        });
        if (!match) {
          showResult(renderMessage("No data found for " + chip.getAttribute("data-area") + ".", "error"));
          return;
        }
        showResult(renderResult(match.record, {
          label: "Area selected",
          meta: match.record.area_name,
          areaCode: match.code
        }));
        highlightArea(match.code);
        scrollResultIntoView();
      }).catch(function () {
        showResult(renderMessage("Something went wrong. Please try again.", "error"));
      });
    });
  });

  input.addEventListener("input", function () {
    if (!areaData) void loadData().catch(function () {});
  });

  /* Patch map colours once data is loaded */
  loadData().then(patchMapColours).catch(function () {});

  initialiseMapSelection();
  initialiseTableInteractions();
  initialiseFromQueryParam();
  initialiseZoom();

  /* ---- Async Add to Cart ---- */
  root.addEventListener('click', function (e) {
    var btn = e.target.closest('.ff-hwm__atc-btn');
    if (!btn) return;
    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.disabled = true;
    btn.textContent = 'Adding…';
    var originalLabel = 'Add to basket';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function (res) {
      if (!res.ok) throw new Error('Cart error');
      return res.json();
    })
    .then(function () {
      btn.textContent = 'Added!';
      btn.classList.add('ff-hwm__atc-btn--added');
      /* Open the AMP slide cart */
      if (typeof window.SLIDECART_OPEN === 'function') {
        window.SLIDECART_OPEN();
      }
      /* Update cart count bubble if theme exposes one */
      var countEl = document.querySelector('.cart-count-bubble, .cart__count, [data-cart-count], .header__cart-count');
      if (countEl) {
        var current = parseInt(countEl.textContent, 10) || 0;
        countEl.textContent = current + 1;
      }
      setTimeout(function () {
        btn.textContent = originalLabel;
        btn.classList.remove('ff-hwm__atc-btn--added');
        btn.disabled = false;
      }, 2500);
    })
    .catch(function () {
      btn.textContent = 'Try again';
      btn.disabled = false;
    });
  });
  /* ── Email capture form handler ── */
  document.addEventListener('submit', function(e) {
    var form = e.target.closest('.ff-hwm__result-email-form');
    if (!form) return;
    e.preventDefault();

    var input = form.querySelector('.ff-hwm__result-email-input');
    var btn   = form.querySelector('.ff-hwm__result-email-btn');
    var email = input ? input.value.trim() : '';

    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      input.focus();
      input.style.borderColor = '#d05b5b';
      setTimeout(function() { input.style.borderColor = ''; }, 1500);
      return;
    }

    var area           = form.dataset.area || '';
    var ppm            = form.dataset.ppm  || '';
    var classification = form.dataset.classification || '';
    var postcode       = form.dataset.postcode || '';
    var lookupMethod   = form.dataset.lookupMethod || 'map';
    var outcode        = form.dataset.outcode || '';
    var waterCompany   = form.dataset.waterCompany || '';
    var supplyZone     = form.dataset.supplyZone || '';
    var ph             = form.dataset.ph || '';
    var chlorine       = form.dataset.chlorine || '';
    var fluoride       = form.dataset.fluoride || '';
    var nitrate        = form.dataset.nitrate || '';
    var lead           = form.dataset.lead || '';
    var iron           = form.dataset.iron || '';
    var turbidity      = form.dataset.turbidity || '';
    var tds            = form.dataset.tds || '';
    var calcium        = form.dataset.calcium || '';
    var magnesium      = form.dataset.magnesium || '';
    var hardnessClark  = form.dataset.hardnessClark || '';
    var hardnessFrench = form.dataset.hardnessFrench || '';
    var hardnessGerman = form.dataset.hardnessGerman || '';
    var hardnessMmol   = form.dataset.hardnessMmol || '';
    var hasQuality     = form.dataset.hasQuality || 'false';
    var chlorineTotal  = form.dataset.chlorineTotal || '';
    var sodium         = form.dataset.sodium || '';
    var trihalomethanes = form.dataset.trihalomethanes || '';
    var gh             = form.dataset.gh || '';
    var kh             = form.dataset.kh || '';
    var arsenic        = form.dataset.arsenic || '';
    var copper         = form.dataset.copper || '';
    var manganese      = form.dataset.manganese || '';
    var eColi          = form.dataset.eColi || '';
    var coliform       = form.dataset.coliform || '';
    var pesticides     = form.dataset.pesticides || '';

    btn.disabled    = true;
    btn.textContent = 'Sending…';

    /* Build Klaviyo properties — only include non-empty values */
    var kProps = {
      water_area:           area,
      water_classification: classification,
      signup_source:        'hard-water-map',
      lookup_method:        lookupMethod,
      water_has_quality_data: hasQuality
    };
    if (ppm)           kProps.water_hardness_ppm    = ppm;
    if (outcode)       kProps.water_outcode          = outcode;
    if (waterCompany)  kProps.water_company          = waterCompany;
    if (supplyZone)    kProps.water_supply_zone      = supplyZone;
    if (ph)            kProps.water_ph               = ph;
    if (chlorine)      kProps.water_chlorine_free    = chlorine;
    if (fluoride)      kProps.water_fluoride         = fluoride;
    if (nitrate)       kProps.water_nitrate          = nitrate;
    if (lead)          kProps.water_lead             = lead;
    if (iron)          kProps.water_iron             = iron;
    if (turbidity)     kProps.water_turbidity        = turbidity;
    if (tds)           kProps.water_tds              = tds;
    if (calcium)       kProps.water_calcium          = calcium;
    if (magnesium)     kProps.water_magnesium        = magnesium;
    if (hardnessClark)  kProps.water_hardness_clark  = hardnessClark;
    if (hardnessFrench) kProps.water_hardness_french = hardnessFrench;
    if (hardnessGerman) kProps.water_hardness_german = hardnessGerman;
    if (hardnessMmol)   kProps.water_hardness_mmol   = hardnessMmol;
    if (chlorineTotal)  kProps.water_chlorine_total  = chlorineTotal;
    if (sodium)         kProps.water_sodium           = sodium;
    if (trihalomethanes) kProps.water_trihalomethanes = trihalomethanes;
    if (gh)             kProps.water_gh               = gh;
    if (kh)             kProps.water_kh               = kh;
    if (arsenic)        kProps.water_arsenic          = arsenic;
    if (copper)         kProps.water_copper           = copper;
    if (manganese)      kProps.water_manganese        = manganese;
    if (eColi !== '')   kProps.water_e_coli           = eColi;
    if (coliform !== '') kProps.water_coliform_bacteria = coliform;
    if (pesticides)     kProps.water_pesticides       = pesticides;

    /* POST to Klaviyo — subscribe to UK Water Hardness Map list (Uemcrn) */
    var klaviyoPayload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'UK Water Hardness Map',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                location: postcode ? { zip: postcode } : undefined,
                properties: kProps,
                subscriptions: {
                  email: {
                    marketing: { consent: 'SUBSCRIBED' }
                  }
                }
              }
            }
          }
        },
        relationships: {
          list: {
            data: { type: 'list', id: 'Uemcrn' }
          }
        }
      }
    };

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=UU6jFQ', {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2026-01-15' },
      body: JSON.stringify(klaviyoPayload)
    })
    .then(function(res) {
      if (!res.ok && res.status !== 202) throw new Error('klaviyo ' + res.status);

      /* Fade out the form content, fade in the confirmation block */
      var capture = form.closest('.ff-hwm__result-email-capture');
      var content = capture ? capture.querySelector('.ff-hwm__result-email-content') : null;
      var confirmEl = capture ? capture.querySelector('.ff-hwm__result-email-confirm') : null;
      if (content) {
        /* Step 1: lock current height so we can animate it */
        if (capture) {
          capture.style.overflow = 'hidden';
          capture.style.height = capture.offsetHeight + 'px';
        }
        content.style.transition = 'opacity 0.25s ease';
        content.style.opacity = '0';
        setTimeout(function() {
          content.style.display = 'none';
          if (capture) { capture.classList.add('is-confirmed'); }
          if (confirmEl) {
            confirmEl.style.display = 'flex';
            confirmEl.style.opacity = '0';
            confirmEl.style.transition = 'opacity 0.25s ease';
            setTimeout(function() { confirmEl.style.opacity = '1'; }, 20);
          }
          /* Step 2: after confirm is visible, collapse height to fit content */
          setTimeout(function() {
            if (capture) {
              var targetH = confirmEl ? (confirmEl.offsetHeight + 32) : 80;
              capture.style.transition = 'height 0.35s ease';
              capture.style.height = targetH + 'px';
            }
          }, 320);
        }, 260);
      }

      /* Unlock the gated Water Quality Parameters panel */
      try { sessionStorage.setItem('ff-hwm-unlocked', '1'); } catch(_e) {}
      var card = form.closest('.ff-hwm__result-card');
      if (card) {
        var gated = card.querySelector('.ff-hwm__quality-panel--gated');
        if (gated) {
          gated.classList.remove('ff-hwm__quality-panel--locked');
          gated.style.opacity = '0';
          gated.style.transition = 'opacity 0.4s ease';
          setTimeout(function() { gated.style.opacity = '1'; }, 20);
        }
      }
    })
    .catch(function() {
      btn.disabled    = false;
      btn.textContent = 'Try again';
    });
  });

  /* ── Share buttons ── */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.ff-hwm__share-btn');
    if (!btn) return;

    var type = btn.dataset.share;
    /* Read context from the parent share row */
    var shareRow = btn.closest('.ff-hwm__result-share');
    var areaCode = shareRow ? shareRow.dataset.shareCode : '';
    var area = shareRow ? shareRow.dataset.shareArea : '';
    var ppm = shareRow ? shareRow.dataset.sharePpm : '';
    var classification = shareRow ? shareRow.dataset.shareClassification : '';

    /* Always use area code URL — no personal postcode data exposed */
    var pageUrl = window.location.origin + window.location.pathname +
      '?area=' + encodeURIComponent(areaCode);

    /* Compose share text */
    var shareText = 'I just checked my water hardness \u2014 ' + area + ' is ' + classification +
      (ppm ? ' (' + ppm.replace('~', '') + ')' : '') +
      '. Yours might be different. Check it free here \u2192 ' + pageUrl;

    if (type === 'whatsapp') {
      window.open('https://wa.me/?text=' + encodeURIComponent(shareText), '_blank', 'noopener');
    } else if (type === 'twitter') {
      window.open('https://twitter.com/intent/tweet?text=' + encodeURIComponent(shareText), '_blank', 'noopener,width=600,height=400');
    } else if (type === 'facebook') {
      window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(pageUrl), '_blank', 'noopener,width=600,height=500');
    } else if (type === 'copy') {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(pageUrl).then(function() {
          var orig = btn.innerHTML;
          btn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="20 6 9 17 4 12"></polyline></svg> Copied!';
          btn.classList.add('ff-hwm__share-btn--copied');
          setTimeout(function() {
            btn.innerHTML = orig;
            btn.classList.remove('ff-hwm__share-btn--copied');
          }, 2000);
        });
      } else {
        /* Fallback for older browsers */
        var ta = document.createElement('textarea');
        ta.value = pageUrl;
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
        btn.textContent = 'Copied!';
        setTimeout(function() { btn.textContent = 'Copy link'; }, 2000);
      }
    }
  });

  /* ── Handle ?area= URL param (from share links) ── */
  /* The param value is an area code (e.g. E09000033), not an area name */
  function initialiseFromAreaParam() {
    var params = new URLSearchParams(window.location.search);
    var areaParam = params.get('area');
    if (!areaParam) return;
    loadData().then(function(areas) {
      /* First try direct area code match */
      var record = areas[areaParam];
      var code = areaParam;
      if (!record) {
        /* Fallback: match by area name (for legacy ?area=Westminster links) */
        var areaName = areaParam.toLowerCase();
        Object.keys(areas).forEach(function(c) {
          if (!record && areas[c].area_name && areas[c].area_name.toLowerCase() === areaName) {
            record = areas[c];
            code = c;
          }
        });
      }
      if (!record) return;
      showResult(renderResult(record, {
        label: 'Shared result',
        meta: record.area_name,
        areaCode: code
      }));
      highlightArea(code);
      scrollResultIntoView();
    }).catch(function() {});
  }

  initialiseFromAreaParam();

})();

